module.exports = __webpack_public_path__ + "static/media/D2_Poker.195784f2.png";